import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { ComplianceMatrixContainer } from './ComplianceMatrix';
export const ComplianceMatrixTab = /*#__PURE__*/ memo(function ComplianceMatrixTab({ projectId }) {
    return /*#__PURE__*/ _jsx(ComplianceMatrixContainer, {
        projectId: projectId
    });
});
